import { getAllTicketsForRace } from '../ticket';

/**
 * Returns boolean whether any races have tickets.
 */
export default (races = []) =>
  races.some((r) => getAllTicketsForRace(r).length > 0);
